import { apiClient } from "@/lib/api";
import {
  isErrorResponse,
  type ErrorResponse,
  type StandardResponse,
} from "@/types/api-response";

// ─── Types ────────────────────────────────────────────────────────────────────

export interface AdminBillingInfoDto {
  id: string;
  tenantId: string;
  tenantType: 0 | 1;
  citizenId: string | null;
  companyName: string;
  taxCode: string | null;
  address: string;
  email: string;
  phone: string | null;
  contactPerson: string | null;
  isPrimary: boolean;
  createdAt: string;
  updatedAt: string | null;
}

// ─── Service ──────────────────────────────────────────────────────────────────

export const adminBillingInfoService = {
  list: async (tenantId?: string): Promise<AdminBillingInfoDto[]> => {
    const params = tenantId ? { tenantId } : {};
    const response = await apiClient.get<
      StandardResponse<AdminBillingInfoDto[]> | ErrorResponse
    >("/api/v1/admin/billing-info", { params });
    if (isErrorResponse(response.data)) {
      throw new Error(response.data.error.message);
    }
    return response.data.data;
  },
};
